import { withDefaults } from "@kalkulacka-one/next/config";

export const appConfig = withDefaults({
  domainPath: "www.volebnikalkulacka.cz",

  i18n: {
    defaultLocale: "cs",
    locales: ["cs"],
    localePrefix: "as-needed" as const,
  },

  links: {
    privacy: "/soukromi",
  },

  footer: {
    statusUrl: "https://status.volebnikalkulacka.cz",
  },
});
